module.exports = __webpack_public_path__ + "static/service-3e7956372bfbb72fc6a8c4bbf87df2d5.jpg";